export default __webpack_public_path__ + "static/media/physicsImage.79914d3d.png";